// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import "firebase/storage";
import { getStorage } from "firebase/storage";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAGt32hIbBj7tlaV9enGLWHAqv6AbMtE3M",
  authDomain: "juba-mall.firebaseapp.com",
  projectId: "juba-mall",
  storageBucket: "juba-mall.appspot.com",
  messagingSenderId: "915126942721",
  appId: "1:915126942721:web:c006bb3e5f02b4ebee9400",
  measurementId: "G-6385JDCRLP",
};

const app = initializeApp(firebaseConfig);
// Create a root reference
const storage = getStorage();

// Initialize Firebase
// const analytics = getAnalytics(app);
const db = getFirestore();
const auth = getAuth(app);

export { auth, storage, db };
